import React from 'react';
import ShopBoxes from '../../../../../../components/shared/ShopBoxes';
import Translation from '../../../../../../services/translation.service';
const BuyingOptions = (props) => {


    return (
        <>
            <div className="newCustomer">
                <h1 className="newCustomerTitle">{Translation.key('hawakom_getplan_lbl1.5_join_lebara')}</h1>
                <ShopBoxes flow='newCustomer' />
            </div>
        </>
    )
}
export default BuyingOptions;